import { arrayOf, exact } from './type-checkers.js';
import { wrapCompositeType } from './util.js';
const base = (model) => {
    return arrayOf(exact(model));
};
const wrappedRecord = wrapCompositeType(base, { type: 'record' }, true);
function record(model) {
    return wrappedRecord(model);
}
export { record, };
//# sourceMappingURL=record.js.map